import React from 'react';
import {Container} from 'react-bootstrap';
import '../layout/main.scss';
import './about.scss';


function About() {
    return (
        <div className="App">
            <div className="about">
                <Container>
                    <h3>About</h3>
                    <div className="mn-blocks">
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default About;
